<template>
    <transition name="slide-fade">
        <div class="modal-mkt" :class="{ 'open': open }" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full p-6 pb-4">
                    <div class="text-center pt-4 pb-4">
                    <div class="text-lg uppercase text-blue-2">{{lbl.register.title.marketing}}</div>
                    <img @click="clickOk()" class="absolute right-7 top-6 w-4" src="../../../assets/icon/dialog/close.svg" />
                </div>
                <div class="text-base h-full overflow-y-auto py-5" v-html="marketingContent"></div>
                <!--<div class="text-center text-blue-2 mt-6" v-html="lbl.register.body.mkt_title"></div>
                     <div class="mt-4">
                        <div class="flex justify-between mb-4 items-center">
                            <div>{{lbl.register.body.mkt_all}}</div>
                            <div @click="handleToggleMkt('all')">
                                <img v-if="mktObject.all" class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_active.png" />
                                <img v-else class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_inactive.png" />
                            </div>
                        </div>
                        <div class="flex justify-between mb-4 items-center">
                            <div>{{lbl.register.body.mkt_email}}</div>
                            <div @click="handleToggleMkt('email')">
                                <img v-if="mktObject.email" class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_active.png" />
                                <img v-else class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_inactive.png" />
                            </div>
                        </div>
                        <div class="flex justify-between mb-4 items-center">
                            <div>{{lbl.register.body.mkt_sms}}</div>
                            <div @click="handleToggleMkt('sms')">
                                <img v-if="mktObject.sms" class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_active.png" />
                                <img v-else class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_inactive.png" />
                            </div>
                        </div>
                        <div class="flex justify-between mb-4 items-center">
                            <div>{{lbl.register.body.mkt_noti}}</div>
                            <div @click="handleToggleMkt('noti')">
                                <img v-if="mktObject.noti" class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_active.png" />
                                <img v-else class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_inactive.png" />
                            </div>
                        </div>
                    </div> -->
                    <div class="flex justify-between mb-4 items-center">
                        <div v-if="acceptedText">{{ lbl.register.buttons.unaccept }}</div>
                        <div v-else>{{ lbl.register.buttons.accept }}</div>
                        <div @click="handleToggleMkt('sms')">
                            <img v-if="mktObject.sms" class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_active.png" />
                            <img v-else class="h-6 w-auto" src="../../../assets/icon/dialog/toggle_inactive.png" />
                        </div>
                    </div>
                    <div class="pb-1">
                        <VBtn @click="saveConsent()"
                            blocked
                            large
                            variant="primary">
                            {{ lbl.default.save }}
                        </VBtn>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";
import VBtn from "@/components/Button/VBtn.vue";

export default {
    name: "MarketingModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    components: {
        VBtn
    },
    data: function () {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,
            marketingContent: '',
            mktObject: {
                all: false,
                email: false,
                sms: false,
                noti: false,
                option: null,
            },
            checkedAccept: false,
            isLoaded: false,
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
        // this.initialMarketing();
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function (config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.initialMarketing().then(() => {
                document.body.classList.add('not-scroll');
                this.isLoaded = true;
                this.open = true;
            });

        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        initialMarketing: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAVersion().subscribe({
                    next: (data) => {
                        this.marketingVersion = data.marketing.current_version
                        this.apiGetMarketing()
                        resolve(true);
                    },
                    error: (err) => {
                        this.errorApi(err)
                        resolve(false);
                    }
                })
            })
        },
        apiGetMarketing: function () {
            BzbsPDPA.apiGetPDPAContent('marketing', this.marketingVersion, this.localeCode + '.txt').subscribe({
                next: (data) => {
                    this.marketingContent = data;
                    this.getConsent();
                },
                error: (err) => {
                    this.errorApi(err)
                }
            })
        },
        getConsent: function() {
            var token = Account.getToken();
            return new Promise((resolve)=>{

                BzbsPDPA.apiGetConsent(token)
                    .subscribe((data) => {
                        console.log(data);
                        var isCheckAll = true;
                        if (data.EmailMarketing) {
                            this.mktObject.email = true;
                        } else {
                            isCheckAll = false;
                        }
                        if (data.SMSMarketing) {
                            this.mktObject.sms = true;
                        } else {
                            isCheckAll = false;
                        }
                        if (data.NotificationMarketing) {
                            this.mktObject.noti = true;
                        } else {
                            isCheckAll = false;
                        }
                        if (isCheckAll) {
                            this.mktObject.all = true;
                        }
                        if (this.mktObject.email || this.mktObject.sms || this.mktObject.noti) {
                            this.mktObject.option = true;
                        }
                        resolve();

                    }, (err) => {
                        this.controller.loadingModal.hide();
                        console.log(err);
                        // this.errorApi(err);
                    });
            });
        },
        saveConsent: async function () {
            this.controller.loadingModal.show();
            var dataMkt = {
                //email: this.mktObject.email ? this.marketingVersion : 0,
                sms: this.mktObject.sms ? this.marketingVersion : 0,
                // notification: this.mktObject.noti ? this.marketingVersion : 0,
                marketingOption: this.mktObject.option ? this.marketingVersion : 0,
            }
            var token = Account.getToken();
            return new Promise((resolve)=>{
                //marketingVersion
                BzbsPDPA.apiPostConsent(token, null, null, dataMkt)
                    .subscribe((data) => {
                        console.log(data);
                        this.clickOk();
                        resolve();

                    }, (err) => {
                        this.controller.loadingModal.hide();
                        this.errorApi(err);
                    });
            });
        },
        handleToggleMkt: function (type) {
            if (type == 'email') {
                this.mktObject.email = !this.mktObject.email;
            }
            if (type == 'sms') {
                this.mktObject.sms = !this.mktObject.sms;
            }
            if (type == 'noti') {
                this.mktObject.noti = !this.mktObject.noti;
            }
            if (type == 'all') {
                this.mktObject.all = !this.mktObject.all;
                if (this.mktObject.all) {
                    this.mktObject.email = true;
                    this.mktObject.sms = true;
                    this.mktObject.noti = true;
                } else {
                    this.mktObject.email = false;
                    this.mktObject.sms = false;
                    this.mktObject.noti = false;
                }

            }
            if (this.mktObject.email && this.mktObject.sms && this.mktObject.noti) {
                this.mktObject.all = true;
            } else {
                this.mktObject.all = false;
            }
            if (this.mktObject.email || this.mktObject.sms || this.mktObject.noti) {
                this.mktObject.option = true;
            }
        },
        clickClose: function() {
            this.hide();
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/style/modal.scss";
.modal-mkt {
    @extend %modal;
    top: unset;
    .modal-content {
        width: 100%;
        border-top-left-radius: 28px;
        border-top-right-radius: 28px;
    }
    .label {
        background-image: url("~@/assets/button/bg.svg");
        background-size: 100%;
    }
}
</style>
